export type NormalizedDomain = {
  origin: string
  hostname: string
  protocol: "http:" | "https:"
}

const HAS_SCHEME = /^[a-z][a-z0-9+.-]*:\/\//i
const HTTP_SCHEME = /^https?:\/\//i

/**
 * Normaliza um domínio informado manualmente:
 * - sem esquema (ex.: "exemplo.com" ou "exemplo.com:8080") assume HTTP;
 * - com esquema HTTP mantém HTTP;
 * - com esquema HTTPS mantém HTTPS.
 * Rejeita credenciais embutidas, esquemas não-HTTP e hosts sem rótulo válido.
 */
export function normalizeDomain(input: string): NormalizedDomain {
  const raw = input.trim()
  if (!raw) throw new Error("Digite um domínio.")
  if (!HTTP_SCHEME.test(raw) && /^https?:/i.test(raw)) throw new Error("Use somente domínios HTTP ou HTTPS.")
  const candidate = HAS_SCHEME.test(raw) ? raw : `http://${raw}`
  let url: URL
  try {
    url = new URL(candidate)
  } catch {
    throw new Error("Informe um domínio válido.")
  }
  if (url.protocol !== "http:" && url.protocol !== "https:") throw new Error("Use somente domínios HTTP ou HTTPS.")
  if (url.username || url.password) throw new Error("Credenciais na URL não são permitidas.")
  const hostname = url.hostname.toLowerCase().replace(/\.$/, "")
  if (!hostname || (!hostname.includes(".") && hostname !== "localhost")) throw new Error("Informe um domínio válido.")
  return { origin: `${url.protocol}//${hostname}${url.port ? `:${url.port}` : ""}`, hostname, protocol: url.protocol }
}
